import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

export function PageHeader({ title, description, actions, className }) {
    return (
        <div className={cn("mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4", className)}>
            <div className="flex items-center gap-4">
                {/* 
                   LAW 9 ENFORCEMENT: Single Brand Anchor.
                   Logo removed from PageHeader to prevent visual noise.
                   It resides in Global Nav only.
                */}

                {/* Page Context */}
                <div>
                    <h1 className="text-3xl font-heading font-extrabold text-primary tracking-tight">
                        {title}
                    </h1>
                    {description && (
                        <div className="text-slate-500 text-sm mt-0.5 flex items-center gap-2 font-medium">
                            {description}
                        </div>
                    )}
                </div>
            </div>

            {/* Actions Area */}
            {actions && (
                <div className="flex items-center gap-3">
                    {actions}
                </div>
            )}
        </div>
    );
}
